import { z } from "zod";

export const analyticsRollupSchema = z.object({
  openIssues: z.number().int().nonnegative(),
  completedIssues: z.number().int().nonnegative(),
  blockedIssues: z.number().int().nonnegative(),
  agentRunsCompleted: z.number().int().nonnegative(),
  cycleThroughput: z.array(
    z.object({
      cycleKey: z.string().min(1),
      completedIssues: z.number().int().nonnegative(),
    }),
  ),
});
